import { Col, Divider, Form, Row, Space } from 'antd'
import { useForm } from 'antd/es/form/Form'
import { FC } from 'react'
import Number from './components/form-items/number/number'
import Width from './components/form-items/width/width'
import Length from './components/form-items/length/length'
import Floods from './components/form-items/floods/floods'
import Roller from './components/form-items/roller/roller'
import Range from './components/form-items/range/range'
import Shape from './components/form-items/shape/shape'
import ImageLink from './components/form-items/image-link/image-link'
import LayoutLink from './components/form-items/layout-link/layout-link'
import Quantity from './components/form-items/quantity/quantity'
import Comment from './components/form-items/comment/comment'
import Locked from './components/form-items/locked/locked'
import getInitialValues from './helpers/get-initial-values'
import Stamp from '../../../../../../../types/api/stamp'
import Save from './components/save/save'
import MaxWidth from './components/form-items/max-width/max-width'
import NumberOfLabelsInFlood from './components/form-items/number-of-labels-in-flood/number-of-labels-in-flood'
import MaterialGroups from './components/form-items/material-types/material-types'
import Contractor from './components/form-items/contractor/contractor'
import ExternalId from './components/form-items/external-id/external-id'
import Radius from './components/form-items/radius/radius'
import ApproximateCost from './components/form-items/approximate-cost/approximate-cost'
import Tubes from './components/form-items/tube/tube'

interface StampFormProps {
    stamp?: Stamp
    copy?: boolean
}

const StampForm: FC<StampFormProps> = ({ stamp, copy = false }) => {
    const [form] = useForm()
    const initialValues = getInitialValues(stamp)

    return (
        <Form layout={'vertical'} form={form} initialValues={initialValues}>
            <Row gutter={18}>
                <Col sm={4}>
                    <Tubes tube={stamp?.tube} />
                </Col>
                <Col sm={4}>
                    <Number />
                </Col>
                <Col sm={4}>
                    <Width />
                </Col>
                <Col sm={4}>
                    <Length />
                </Col>
                <Col sm={4}>
                    <Floods />
                </Col>
                <Col sm={4}>
                    <Roller />
                </Col>
                <Col sm={4}>
                    <Range />
                </Col>
                <Col sm={4}>
                    <Shape />
                </Col>
                <Col sm={4}>
                    {/* <Material /> */}
                    <MaterialGroups />
                </Col>
                <Col sm={4}>
                    <Quantity />
                </Col>
                <Col sm={4}>
                    <Comment />
                </Col>
                <Col sm={4}>
                    <ImageLink />
                </Col>
                <Col sm={4}>
                    <LayoutLink />
                </Col>
                <Col sm={4}>
                    <Locked />
                </Col>
                <Col sm={4}>
                    <Contractor />
                </Col>
                <Col sm={4}>
                    <ExternalId />
                </Col>
                <Col sm={4}>
                    <Radius />
                </Col>
                <Col sm={4}>
                    <ApproximateCost />
                </Col>
                <Col sm={24}>
                    <Divider orientation={'left'}>Рассчитаные характеристики</Divider>
                </Col>
                {/* <Col sm={4}>
                    <Teeth />
                </Col> */}
                <Col sm={4}>
                    <MaxWidth />
                </Col>
                <Col sm={4}>
                    <NumberOfLabelsInFlood />
                </Col>
                <Col sm={24}>
                    <Space>
                        <Save stamp={stamp} copy={copy} form={form} />
                    </Space>
                </Col>
            </Row>
        </Form>
    )
}

export default StampForm
